// import Viewer from 'viewerjs';
class imageViewer {
    init() {

    }

    initViewer() {
        lightbox.option({
            'resizeDuration': 200,
            'wrapAround': true
          });
 

        // const gallery = new Viewer(document.getElementById('images'));

        // // var viewer = new Viewer(el, {
        // //     url: 'href',
        // //     hidden: function () {
        // //         viewer.destroy();
        // //     },
        // // });
        // // var viewer = new Viewer();
        // const images = Array.from(el.querySelectorAll('[data-lightbox]'));
        // console.log(images);
        // images.forEach(image => {
        //     var img = new Image();
        //     img.src = image.getAttribute('href');

        //     // var viewer = new Viewer(img, {
        //     //     hidden: function () {
        //     //         viewer.destroy();
        //     //     },
        //     // });

        //     gallery.update(img)


        //     image.addEventListener('click', (click) => {
        //         console.log(click);
        //         click.preventDefault();
        //         // click.stopPropagation();
        //         // return false;
        //         // $(modal).on('shown.bs.modal', (e) => {
        //         //     $(modal).off('shown.bs.modal');
        //         //     this.glide = new Glide(
        //         //         modal.querySelector('.glide'), {
        //         //         startAt: slide,
        //         //         animationDuration: 0,
        //         //     }
        //         //     );
        //         //     this.glide.mount();
        //         //     Array.from(modal.querySelectorAll('.arrow')).forEach(arrow => {
        //         //         arrow.addEventListener('click', () => {
        //         //             this.glide.go(arrow.getAttribute('data-dir'));
        //         //         });
        //         //     });
        //         // });
        //         // $(modal).on('hidden.bs.modal', () => {
        //         //     $(modal).off('hidden.bs.modal');
        //         //     this.glide.destroy();
        //         // });
        //         // $(modal).modal();
        //         gallery.show();
        //     });
        // });
        // gallery.show();

        // // image.src = '../images/tibet-1.jpg';


        // // image.click();
        // // const gallery = new Viewer(el); 

    }

}

window.app.add('images', new imageViewer());